import { render } from "./IconFavorites.vue?vue&type=template&id=4804b0b8"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconFavorites.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4804b0b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4804b0b8', __exports__)) {
    api.reload('4804b0b8', __exports__)
  }
  
  module.hot.accept("./IconFavorites.vue?vue&type=template&id=4804b0b8", () => {
    api.rerender('4804b0b8', render)
  })

}


export default __exports__